import axiosConfig from "./axiosConfig";

class UserService {
    async getAll() {
        try {
            const response = await axiosConfig.get("/users");
            return response.data || [];
        } catch (error) {
            console.error("Error fetching users:", error);
            return [];
        }
    }

    async getById(id) {
        try {
            const response = await axiosConfig.get(`/users/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching user with ID ${id}:`, error);
            throw error;
        }
    }

    async create(formData) {
        try {
            const response = await axiosConfig.post("/users", formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            console.error("❌ Error creating user:", error.response?.data || error.message);
            return Promise.reject(error.response?.data || { message: error.message });
        }
    }

    async update(id, formData) {
        try {
            const response = await axiosConfig.patch(`/users/${id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            console.error(`❌ Error updating user with ID ${id}:`, error.response?.data || error.message);
            return Promise.reject(error.response?.data || { message: error.message });
        }
    }

    async delete(id) {
        try {
            const response = await axiosConfig.delete(`/users/${id}`);
            return response.data;
        } catch (error) {
            console.error(`❌ Error deleting user with ID ${id}:`, error.response?.data || error.message);
            return Promise.reject(error.response?.data || { message: error.message });
        }
    }

    async activate(id) {
        try {
            const response = await axiosConfig.patch(`/users/${id}/activate`);
            return response.data;
        } catch (error) {
            console.error(`❌ Error activating user with ID ${id}:`, error.response?.data || error.message);
            return Promise.reject(error.response?.data || { message: error.message });
        }
    }

    async deactivate(id) {
        try {
            const response = await axiosConfig.patch(`/users/${id}/deactivate`);
            return response.data;
        } catch (error) {
            console.error(`❌ Error deactivating user with ID ${id}:`, error.response?.data || error.message);
            return Promise.reject(error.response?.data || { message: error.message });
        }
    }

    async updateAvatar(id, formData) {
        try {
            const response = await axiosConfig.post(`/users/${id}/avatar`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            console.error(`❌ Error updating avatar for user with ID ${id}:`, error.response?.data || error.message);
            return Promise.reject(error.response?.data || { message: error.message });
        }
    }
}

const UserServiceInstance = new UserService();
export default UserServiceInstance;